export const CONTENT_TYPE = {
  COURSE: "course",
  SKILLS_PATH: "skillsPath",
};
  